import React, { useState } from "react";
import Tabs from "../Tabs/Tabs";
import "./CardStats.scss";

const CardStats = ({
    title,
    subtitle,
    data,
    percentage = true,
    hasChart = false,
    children,
}) => {
    const [activeTab, setActiveTab] = useState("Semana");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const currentMetrics = data?.metrics?.[activeTab] || {};
    const { amount, percentageValue, percentageText } = currentMetrics;

    const isNegative = percentageValue < 0;

    return (
        <div
            className={`card-stats ${
                hasChart ? "card-stats--with-chart" : "card-stats--stats-only"
            }`}
        >
            <div className="card-stats__header">
                <div className="card-stats__info">
                    <div className="card-stats__text">
                        <h3 className="card-stats__title">{title}</h3>
                        <p className="card-stats__subtitle">{subtitle}</p>
                    </div>

                    <Tabs onTabChange={handleTabChange} />
                </div>

                <div className="card-stats__metrics">
                    {amount && <h2 className="card-stats__amount">{amount}</h2>}
                    {percentage && percentageValue !== undefined && (
                        <div
                            className={`card-stats__percentage ${
                                isNegative
                                    ? "card-stats__percentage--negative"
                                    : "card-stats__percentage--positive"
                            }`}
                        >
                            <span className="card-stats__percentage-icon">
                                {isNegative ? "↓" : "↑"}
                            </span>
                            {Math.abs(percentageValue)}%
                            <span className="card-stats__percentage-text">
                                {percentageText}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {hasChart && children && (
                <div className="card-stats__content">
                    <div className="card-stats__chart-container">
                        {React.cloneElement(children, {
                            data: data?.chartData,
                            activeTab,
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CardStats;
